import React from 'react';
import { Box, Breadcrumbs, Typography } from "@mui/material";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import FormApproval from '../../../components/approval/FormApproval';

export const LayoutApproval = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const data = location?.state?.config?.data;
    console.log('LayoutApproval ', data);

    const handleClose = () => {
        navigate(-1);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ mb: 2, pt: 2, pl: 2, pr: 2 }}>
                <Breadcrumbs aria-label="breadcrumb" separator="›" sx={{ mb: 2 }}>
                    <Link to="/tableViews/:params" underline="hover" color="text.main" sx={{ cursor: 'pointer' }}>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            Reglas Aprobacion
                        </Typography>
                    </Link>
                </Breadcrumbs>
            </Box>
            <FormApproval
                handleClose={handleClose}
                data={data}
                open
            />
        </Box>
    );
};
